import { UserType } from "generated/graphql";
import { redirect } from "react-router-dom";
import RequestStatus from "redux/slices/RequestStatus";
import { getSession } from "redux/slices/session";
import store from "redux/store";

export const reportLoader = async () => {
  store.getState().session.status !== RequestStatus.SUCCEEDED
    ? await store.dispatch(getSession())
    : await Promise.resolve();
  const isReviewer = store.getState().session.session?.userType === UserType.Reviewer;
  return isReviewer ? redirect("..") : null;
};
